export default function ItemFieldSeason({ seasonData }) {
  if (!seasonData) return null;

  return (
    <>
      <div className="flex flex-col  w-56 justify-center items-start gap-4 p-2 box-shadow rounded-xl">
        <div className="w-full flex flex-col justify-between items-center">
          <p className="text-base font-semibold text-[#2e2e2e] max-lg:mt-2">
            فصل رشد{seasonData.name}
          </p>
        </div>

        <div className="flex w-full flex-wrap justify-between gap-6 max-lg:gap-y-2">
          <div className="flex flex-row gap-1 w-[12rem] max-lg:w-full justify-between text-agrotext font-semibold text-sm max-lg:gap-[2px]">
            <h3> نام محصول:</h3>
            <p className="font-normal"> {seasonData?.product?.persianName}</p>
          </div>

          {seasonData?.cultivarName && (
            <div className="flex flex-row gap-1 w-[12rem] max-lg:w-full justify-between text-agrotext font-semibold text-sm max-lg:gap-[2px]">
              <h3>نام رقم:</h3>
              <p className="font-normal">{seasonData?.cultivarName}</p>
            </div>
          )}

          <div className="flex flex-row gap-1 w-[12rem] max-lg:w-full justify-between text-agrotext font-semibold text-sm max-lg:gap-[2px]">
            <h3> سیستم آبیاری:</h3>
            <p className="font-normal">{seasonData?.irrigationSystem}</p>
          </div>

          {seasonData?.plantingDate && (
            <div className="flex flex-row gap-1 text-sm w-[12rem] max-lg:w-full justify-between text-agrotext font-semibold">
              <h3> تاریخ کاشت:</h3>
              <p className="font-normal">{seasonData?.plantingDate}</p>
            </div>
          )}

          <div className="flex flex-row gap-1 text-sm w-[12rem] max-lg:w-full whitespace-nowrap justify-between text-agrotext font-semibold">
            <h3>تاریخ برداشت:</h3>
            <p className="font-normal">{seasonData.date}</p>
          </div>

          {seasonData?.usedSeedAmount && (
            <div className="flex flex-row gap-1 whitespace-nowrap w-[12rem] max-lg:w-full justify-between text-agrotext font-semibold text-sm max-lg:gap-[2px]">
              <h3> میزان بذر مصرفی:</h3>
              <p className="font-normal">{seasonData?.usedSeedAmount} کیلوگرم </p>
            </div>
          )}

          {seasonData?.density && (
            <div className="flex flex-row gap-1 w-[12rem] max-lg:w-full justify-between text-agrotext font-semibold text-sm max-lg:gap-[2px]">
              <h3>تراکم :</h3>
              <p className="font-normal">{seasonData?.density} در هکتار</p>
            </div>
          )}

          {seasonData.description && (
            <div className="flex flex-row gap-1 w-[12rem] max-lg:w-full justify-between text-agrotext font-semibold text-sm max-lg:gap-[2px]">
            <h3>توضیحات :</h3>
            <p className="font-normal w-28 !text-left">{seasonData.description}</p>
          </div>
          )}
        </div>
      </div>
    </>
  );
}
